import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleTextSpecification extends FlexibleBaseSpecification {
	id: number;
	value: string;
	size: string;
	weight: string;
	color: string;
}

export class FlexibleTextModel extends FlexibleModelBase {
	public readonly value: string;
	public readonly size: string;
	public readonly weight: string;
	public readonly color: string;

	constructor(spec: FlexibleTextSpecification) {
		super(spec);

		this.value = spec.value;
		this.size = spec.size;
		this.weight = spec.weight;
		this.color = spec.color;
	}
}
